/**
 * ModalPortal Component
 * Renders children to document.body using React Portal.
 * This ensures modals are positioned correctly even when parent
 * elements have CSS transforms applied (like PullToRefresh).
 */

import { createPortal } from 'react-dom';

interface ModalPortalProps {
  children: React.ReactNode;
}

export default function ModalPortal({ children }: ModalPortalProps) {
  return createPortal(children, document.body);
}
